/**
 * CashFlowDashboardPage
 * 
 * Landing page for the Cash Flow module.
 * Shows the main cash flow dashboard with financial insights.
 */

import { CashflowDashboard } from '@/components/cashflow/CashflowDashboard';

export function CashFlowDashboardPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">תזרים מזומנים</h1>
          <p className="text-gray-600 mt-1">סקירה כללית של המצב הפיננסי</p>
        </div>
      </div>
      
      <CashflowDashboard />
    </div>
  );
}
